import CheckoutConfig from '@/shared/models/CheckoutConfig'

export default class Address {
  main?: string

  number?: string

  additional?: string

  locality?: string

  city?: string

  state?: string

  country?: string

  zipCode?: string

  constructor(config: CheckoutConfig) {
    this.main = config.addressMain
    this.number = config.addressNumber
    this.additional = config.addressAdditional
    this.locality = config.addressLocality
    this.city = config.addressCity
    this.state = config.addressState
    this.country = config.addressCountry
    this.zipCode = config.addressZipCode
  }

  get isIncomplete(): boolean {
    return (
      Boolean(this.zipCode) && (
        !this.main
        || !this.locality
        || !this.state
        || !this.city
      )
    )
  }
}
